import { FREE_RIGHTS, rightsFor, type EntitlementState, type Rights } from './entitlement';

let current: Rights = FREE_RIGHTS;
let epoch = 0;
const listeners = new Set<(rights: Rights) => void>();

function publish() {
  for (const listener of listeners) listener(current);
}

/**
 * Ephemeral, local-only projection of the authenticated server ledger. It is
 * deliberately not written to trip records, exports, analytics, or storage.
 */
export function currentRights(): Rights {
  return current;
}

/** Starts a new authenticated projection. A response from an older epoch is ignored. */
export function beginRightsSession(): number {
  epoch += 1;
  current = FREE_RIGHTS;
  publish();
  return epoch;
}

export function currentRightsSessionEpoch(): number {
  return epoch;
}

export function applyVerifiedRights(readback: { verified: boolean; state: EntitlementState }, responseEpoch = epoch): Rights {
  if (responseEpoch !== epoch) return current;
  current = readback.verified ? rightsFor(readback.state) : FREE_RIGHTS;
  publish();
  return current;
}

export function resetRights(responseEpoch = epoch): Rights {
  if (responseEpoch !== epoch) return current;
  current = FREE_RIGHTS;
  publish();
  return current;
}

export function subscribeRights(listener: (rights: Rights) => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
